import { decodeQueryString, encodeQueryString } from '../../../../app/queryString'
import { SubMenuTabs } from '../../../components/SubMenu/SubMenuTabs'
import { FINANCIALS_SECTION_LABELS, QuoteRoutes } from '../../../constants'

const FINANCIAL_MENU_TABS: Array<keyof typeof FINANCIALS_SECTION_LABELS> = [
  QuoteRoutes.Dividends,
  QuoteRoutes.Earnings,
  QuoteRoutes.Revenue,
  QuoteRoutes.Forecast,
]

function getFinancialMenuTabs() {
  const searchParams = decodeQueryString()

  return FINANCIAL_MENU_TABS.map((value) => ({
    label: FINANCIALS_SECTION_LABELS[value],
    href: `/quote.ashx?${encodeQueryString({ ...searchParams, ty: value })}`,
    isActive: searchParams.ty === value,
    reloadDocument: true,
  }))
}

export function QuoteFinancialsTabMenu() {
  return <SubMenuTabs items={getFinancialMenuTabs()} />
}
